/**
 * Active view options for the Hero section.
 *
 * Single enum for the current hero sub-view.
 * - VISUALIZATION — static site render (no rotation)
 * - SITE          — 360° rotatable model of the whole estate
 * - BUILDING      — 360° rotatable model of a single building (drill-down from SITE)
 *
 * Which values are actually available depends on `heroCapabilities.availableViews`.
 */
export const HERO_VIEW = {
  VISUALIZATION: 'visualization',
  SITE:          'site',
  BUILDING:      'building',
}
